export * from './supervisor-edit';
export * from './supervisor-list';
export * from './supervisor-new';

export * from './supervisor.component';
